<template>
  <div class="app-header-sticky" :class="{ show: y >= 35 }">
    <div class="container" v-show="y >= 35">
      <RouterLink class="logo" to="/" />
      <AppHeaderNav />
      <div class="right">
        <RouterLink to="/about">品牌</RouterLink>
        <RouterLink to="/">专题</RouterLink>
      </div>
    </div>
  </div>
</template>
<script>
import AppHeaderNav from "./app-header-nav";
import { useWindowScroll } from "@vueuse/core";
export default {
  name: "AppHeaderSticky",
  components: { AppHeaderNav },
  setup() {
    const { y } = useWindowScroll();
    //console.log(y);
    return { y };
  },
};
</script>

<style scoped lang="less">
.app-header-sticky {
  width: 100%;
  height: 80px;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
  background-color: #fff;
  border-bottom: 1px solid #e4e4e4;
  transform: translateY(-100%);
  opacity: 0;
  &.show {
    transition: all 0.3s linear;
    transform: none;
    opacity: 1;
  }
}
.container {
  display: flex;
  align-items: center;
  height: 80px;
}
.logo {
  width: 230px;
  height: 45px;
  background: url(../assets/images/logo.png) no-repeat right 2px;
  background-size: 160px auto;
  align-items: center;
}
.right {
  width: 230px;
  display: flex;
  text-align: center;
  padding-left: 40px;
  border-left: 2px solid @shColor;
  justify-content: space-around;
  a {
    width: 38px;
    margin-right: 40px;
    font-size: 16px;
    line-height: 1;
    &:hover {
      color: @shColor;
    }
  }
}
</style>
